<vs-icon *ngIf="config && config.iconStart" [name]="config.iconStart"></vs-icon>
<div
  *ngIf="config && config.displayStatusIcon"
  class="h-1.5 w-1.5 rounded-full bg-themed-600"
  [theme]="config.statusIconTheme"
></div>
<ng-content></ng-content>
<vs-icon *ngIf="config && config.iconEnd" [name]="config.iconEnd"></vs-icon>
